module.exports = __webpack_public_path__ + "img/KirstenRothe_140x140_rund.6258ea66.jpg";